import React from "react";

import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { AddCircle } from "@mui/icons-material";

interface CreateNewCardProps {
  title: string;
  onClick: () => void;
}

const CreateNewCard: React.FC<CreateNewCardProps> = ({ title, onClick }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        background: "transparent",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "220px",
        height: "200px",
      }}
    >
      <CardActionArea onClick={onClick}>
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <AddCircle color="primary" sx={{ fontSize: 50 }} />
          <Typography variant="h6" mt={1} sx={{ textAlign: "center" }}>
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CreateNewCard;
